"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupsTeamsIdentifier = exports.TransactionType = exports.GroupName = void 0;
var GroupName;
exports.GroupName = GroupName;

(function (GroupName) {
  GroupName["Ungrouped"] = "ungrouped";
  GroupName["AllGroupsAndTeams"] = "all_groups_and_teams";
})(GroupName || (exports.GroupName = GroupName = {}));

var TransactionType;
exports.TransactionType = TransactionType;

(function (TransactionType) {
  TransactionType["Unknown"] = "unknown";
  TransactionType["Deposit"] = "deposit";
  TransactionType["HistoricDeposit"] = "historic_deposit";
  TransactionType["Withdrawal"] = "withdrawal";
  TransactionType["Withdraw"] = "withdraw";
  TransactionType["GiftingWithdrawal"] = "gifting_withdrawal";
  TransactionType["HistoricWithdraw"] = "historic_withdraw";
  TransactionType["HistoricInvoice"] = "historic_invoice";
})(TransactionType || (exports.TransactionType = TransactionType = {}));

var GroupsTeamsIdentifier;
exports.GroupsTeamsIdentifier = GroupsTeamsIdentifier;

(function (GroupsTeamsIdentifier) {
  GroupsTeamsIdentifier["Ungrouped"] = "ungrouped";
  GroupsTeamsIdentifier["AllGroupsAndTeams"] = "all_groups_and_teams";
})(GroupsTeamsIdentifier || (exports.GroupsTeamsIdentifier = GroupsTeamsIdentifier = {}));